import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-067e5de6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "p_header" }
const _hoisted_2 = { class: "page_title" }
const _hoisted_3 = { class: "page_content_customize_width" }
const _hoisted_4 = { id: "p_qrcode" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "p_qrcode_img",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { id: "p_qrcode_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($data.title), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString($data.des), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString($data.qrCodeTips), 1)
    ])
  ]))
}